import ReconnectingWebSocket from 'reconnecting-websocket'
import { Crypt } from 'hybrid-crypto-ts'
import { api_public_key, webSocketsUrl } from '../configs'
import { store } from '../Redux'
import { EventRegister } from 'react-native-event-listeners'

const crypt = new Crypt()

const ws = new ReconnectingWebSocket(webSocketsUrl, [], {
    constructor: WebSocket,
    connectionTimeout: 5000,
    reconnectInterval: 1000,
} as any)

export const sendData = (data: any) => {
    try {
        ws.send(crypt.encrypt(api_public_key, JSON.stringify({
            ...data,
            token: (store.getState() as any).jwtToken,
        })))
    } catch (e) {
        console.warn('sendData failed:', e)
    }
}

ws.onopen = () => {
    const { User, qrSessionId } = store.getState() as any
    if (User) {
        sendData({ action: 'userOnline' })
    } else if (qrSessionId) {
        sendData({ action: 'userConnected', sessionId: qrSessionId })
    }
}

ws.onmessage = (e: MessageEvent) => {
    try {
        const data = JSON.parse(e.data)
        switch (data.action) {
            case 'qrLogin':
                EventRegister.emit('socket', data)
                break
            default:
                break
        }
    } catch { }
}

ws.onerror = (e) => console.warn('WS error:', e)
ws.onclose = () => console.log('WS closed, reconnecting...')
